/* global caiprivacy */
const appStore = [{
  href: 'https://apps.apple.com/us/app/autotrader-shop-all-the-cars/id700740807?itsct=apps_box_link&itscg=30200',
  src: 'https://atc-cms-dam.s3.amazonaws.com/content/dam/autotrader/global/footer/app-store-badge-apple.svg',
  alt: 'apple app store',
  'aria-label': 'Download on the Apple App Store',
  gaAppStoreName: 'apple-store',
  imgWidth: '144px',
  imgHeight: '48px'
}, {
  href: 'https://play.google.com/store/apps/details?id=com.autotrader.android',
  src: 'https://atc-cms-dam.s3.amazonaws.com/content/dam/autotrader/global/footer/app-store-badge-google.png',
  alt: 'google play store',
  'aria-label': 'Get it on Google Play',
  gaAppStoreName: 'google-play-store',
  imgWidth: '161px',
  imgHeight: '48px'
}];
export const carAndDriverSocialIcons = [{
  rel: 'nofollow noopener',
  href: 'https://x.com/caranddriver',
  src: 'https://autotrader.com/cm-api/content/static/img/caranddriver/X.svg',
  alt: 'x',
  width: '17px',
  height: '17px'
}, {
  rel: 'nofollow noopener',
  href: 'https://www.tiktok.com/@caranddriver?lang=en',
  src: 'https://autotrader.com/cm-api/content/static/img/caranddriver/tiktok.svg',
  alt: 'tiktok',
  width: '17px',
  height: '17px'
}, {
  rel: 'nofollow noopener',
  href: 'https://www.youtube.com/caranddriver',
  src: 'https://autotrader.com/cm-api/content/static/img/caranddriver/youtube.svg',
  alt: 'youtube',
  width: '17px',
  height: '17px'
}, {
  rel: 'nofollow noopener',
  href: 'https://www.facebook.com/caranddriver',
  src: 'https://autotrader.com/cm-api/content/static/img/caranddriver/facebook.svg',
  alt: 'facebook',
  width: '17px',
  height: '17px'
}, {
  rel: 'nofollow noopener',
  href: 'https://www.instagram.com/caranddriver/',
  src: 'https://autotrader.com/cm-api/content/static/img/caranddriver/instagram.svg',
  alt: 'instagram',
  width: '17px',
  height: '17px'
}];

// used in NonstaticFooter
export const social = [{
  rel: 'nofollow noopener',
  title: 'Become a Fan of Autotrader on Facebook',
  href: 'https://www.facebook.com/autotrader',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/Facebook.svg',
  alt: 'facebook',
  imgWidth: '18px',
  imgHeight: '18px'
}, {
  rel: 'nofollow noopener',
  title: 'Follow Autotrader on X',
  href: 'https://x.com/autotrader_com',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/X.svg',
  alt: 'x',
  imgWidth: '16px',
  imgHeight: '16px'
}, {
  rel: 'nofollow noopener',
  title: 'See Autotrader videos on Youtube',
  href: 'https://www.youtube.com/autotrader',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/Youtube.svg',
  alt: 'youtube',
  imgWidth: '22px',
  imgHeight: '16px'
}, {
  rel: 'nofollow noopener',
  title: 'RSS',
  href: '/feed',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/rss.svg',
  alt: 'rss',
  imgWidth: '22px',
  imgHeight: '22px'
}];

// used in white StaticFooter
export const socialIcons = [{
  rel: 'nofollow noopener',
  title: 'Become a Fan of Autotrader on Facebook',
  href: 'https://www.facebook.com/autotrader',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/facebook_gray.svg',
  alt: 'facebook'
}, {
  rel: 'nofollow noopener',
  title: 'Follow Autotrader on X',
  href: 'https://x.com/autotrader_com',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/x_gray.svg',
  alt: 'x'
}, {
  rel: 'nofollow noopener',
  title: 'See Autotrader videos on Youtube',
  href: 'https://www.youtube.com/autotrader',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/youtube_gray.svg',
  alt: 'youtube'
}, {
  rel: 'nofollow noopener',
  title: 'RSS',
  href: '/feed',
  src: 'https://autotrader.com/cm-api/content/static/img/icon/socials/rss_gray_no_shadow.svg',
  alt: 'rss'
}];
export const rawSitemapData = [{
  title: 'Shop for a Car',
  items: [{
    href: '/cars-for-sale',
    text: 'Used Cars For Sale',
    pagetype: 'slp_used'
  }, {
    href: '/certified-cars',
    text: 'Certified Cars',
    pagetype: 'slp_cpo'
  }, {
    href: '/car-deals',
    text: 'Car Deals',
    pagetype: 'cardeals-article_results_car-deals'
  }]
}, {
  title: 'Car Research',
  items: [{
    href: 'https://www.kbb.com/car-values/',
    target: '_blank',
    text: 'Trade-In Values and Car Pricing',
    pagetype: 'car_val_syc',
    glyph: 'offsite'
  }, {
    href: '/car-subscription-services',
    text: 'Car Subscription Services',
    pagetype: 'car_subst_serv'
  }]
}, {
  title: 'About Us',
  items: [{
    href: '/about/index',
    text: 'Company Information',
    pagetype: 'article_company-information'
  }, {
    href: 'https://www.coxautoinc.com',
    rel: 'nofollow noopener',
    target: '_blank',
    text: 'Corporate Information',
    pagetype: 'article_corporate-information'
  }, {
    href: 'https://jobs.coxenterprises.com/en/about-cox/businesses/cox-automotive/autotrader',
    rel: 'nofollow noopener',
    text: 'Jobs at Autotrader',
    pagetype: 'jbs_atc'
  }, {
    href: 'https://b2b.autotrader.com/#contact-form',
    rel: 'nofollow noopener',
    target: '_blank',
    text: 'Become an Autotrader Dealer',
    pagetype: 'become_atc_dealer'
  }, {
    href: 'https://press.autotrader.com',
    rel: 'noopener',
    text: 'Press Room',
    pagetype: 'press_room'
  }, {
    href: '/help/sitemap',
    text: 'Site Map',
    pagetype: 'site_map'
  }, {
    href: '/help/contact',
    text: 'Contact Us',
    pagetype: 'contact_us'
  }, {
    href: '/about/index',
    rel: 'nofollow',
    text: 'About Autotrader',
    pagetype: 'article_help'
  }, {
    callback: () => caiprivacy?.doNotSellOrShareMyPersonalInformation(),
    rel: 'noopener',
    target: '_blank',
    text: 'Do Not Sell or Share My Personal Information',
    pagetype: 'privacy-request'
  }, {
    callback: () => caiprivacy?.limitTheUseOfMySensitivePersonalInformation(),
    rel: 'noopener',
    target: '_blank',
    text: 'Limit the Use of My Sensitive Personal Information',
    pagetype: 'privacy-request'
  }, {
    href: '/legal/fraud-awareness',
    text: 'Fraud Awareness',
    pagetype: 'article_fraud-awarness'
  }, {
    callback: () => caiprivacy?.manageCookies(),
    text: 'Manage Cookies'
  }]
}, {
  title: 'Autotrader Affiliates',
  items: [{
    img: '/content/web/images/partners/no_img_1pixel.png',
    text: 'Classic Cars & Trucks for Sale',
    href: 'https://classics.autotrader.com/?utm_source=atc&utm_medium=links&utm_content=atcfot&utm_campaign=partnership',
    rel: 'noopener',
    target: '_blank',
    glyph: 'offsite',
    pagetype: 'classic_exotic_cars'
  }, {
    img: '/content/web/images/partners/no_img_1pixel.png',
    text: 'Motorcycles for Sale',
    href: 'https://motorcycles.autotrader.com/?utm_source=atc&utm_medium=links&utm_content=atcfot&utm_campaign=partnership',
    rel: 'noopener',
    target: '_blank',
    glyph: 'offsite',
    pagetype: 'motorcycles_sale'
  }, {
    img: '/content/web/images/partners/no_img_1pixel.png',
    text: 'RVs for Sale',
    href: 'https://rvs.autotrader.com/?utm_source=atc&utm_medium=links&utm_content=atcfot&utm_campaign=partnership',
    rel: 'noopener',
    target: '_blank',
    glyph: 'offsite',
    pagetype: 'rvs_sale'
  }, {
    img: '/content/web/images/partners/no_img_1pixel.png',
    text: 'Cars for Bad Credit Buyers',
    href: 'https://buyherepayhere.autotrader.com/?utm_source=atc&utm_medium=links&utm_content=atcfot&utm_campaign=partnership',
    rel: 'noopener',
    target: '_blank',
    glyph: 'offsite',
    pagetype: 'cars_bad_credit_buyers'
  }, {
    img: '/content/web/images/partners/no_img_1pixel.png',
    text: 'Find Cars for Sale in Australia',
    href: 'https://autotrader.com.au/?utm_source=atc&utm_medium=links&utm_content=atcfot&utm_campaign=partnership',
    rel: 'noopener',
    target: '_blank',
    glyph: 'offsite',
    pagetype: 'cars_sale_australia'
  }]
}];
function formatSitemapData(data) {
  // Build appropriate structure sitemap column data from flat sitemap array
  const tempData = [...data];
  const firstColumn = tempData.splice(0, 2);
  tempData.unshift([...firstColumn]);
  return tempData;
}
export const sitemap = formatSitemapData(rawSitemapData);
export default {
  appStore,
  carAndDriverSocialIcons,
  sitemap,
  social,
  socialIcons
};